<script>
	import { nanoid } from "nanoid";

	export let id = nanoid(6);
	export let label = null;
	export let sublabel = null;
	export let value = null;
	export let maxlength = null;
	export let required = false;
	export let disabled = false;
	export let placeholder = null;
	export let inputmode = null;
	export let control = null;
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}
<input
	{id}
	class="form-control"
	type="text"
	{required}
	{disabled}
	{placeholder}
	{maxlength}
	{inputmode}
	bind:value
	on:change
	bind:this={control} />
